import { IconPrefix } from "@fortawesome/free-solid-svg-icons";
import {
    IFontAwesomeIcon,
    IFontAwesomeIconLookup,
    IFontAwesomeIconSearchResponse,
    IFontAwesomeReleaseIconsResponse,
    TFontAwesomeIconStyle,
} from "../../../Interfaces/Utils/FontAwesome";
import { ListarIconsFontAwesomeService } from "../../../Services/Tools/FontAwesome/FontAwesomeServices";
import { APIError } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

const iconPref: Record<TFontAwesomeIconStyle, IconPrefix> = {
    solid: "fas",
    brands: "fab",
    regular: "far",
};

export async function ListarIconsFontAwesomeController(search?: string) {
    return Controller(
        ListarIconsFontAwesomeService(search)
            .then((res) => {
                if (res.data.errors)
                    throw res.data.errors.map(
                        (e: { message: string }) => e.message
                    );
                return res;
            })
            .catch((err) => {
                throw new APIError({
                    title: "Erro ao listar ícones",
                    erroFormal: err,
                    erroInformal:
                        "Algum erro ocorreu e não foi posível listar os ícones.",
                });
            })
    ).then((res) => {
        let icons: Array<IFontAwesomeIcon> = [];
        if (search) {
            const responseData = res as IFontAwesomeIconSearchResponse;
            icons = responseData.data.search.filter(
                (i) => i.membership.free.length > 0
            );
        } else {
            const responseData = res as IFontAwesomeReleaseIconsResponse;
            icons = responseData.data.release.icons.slice(0, 30);
        }
        return icons.reduce((iconsLookup, i) => {
            i.membership.free.forEach((pref) => {
                iconsLookup.push({
                    iconName: i.id,
                    prefix: iconPref[pref],
                    label: i.label,
                });
            });
            return iconsLookup;
        }, [] as Array<IFontAwesomeIconLookup>);
    });
}
